import Vue from 'vue'
import Vuex from 'vuex'
import axios from './axios';

import auth from './modules/auth';
import academic from './modules/academic';
import news from './modules/news';
import document from './modules/document';
import form from './modules/form';
import activity from './modules/activity';
import slide from './modules/slide';
import about from './modules/about';
import faq from './modules/faq';
import calendar from './modules/calendar';
import km from './modules/km';
import job from './modules/job';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    header: true,
    sidebar: true,
    footer: true,
    breadcrumbs: [],
    snackbar: {
      show: false,
      color: '',
      message: ''
    },
    drawer: false,
    loading: false,
    confirm_dialog: {
      dialog: false,
      color: '',
      message: ''
    },
    departments: [],
    position_works: [],
    announcement_types: []
  },
  mutations: {
    SET_HEADER(state, val) { state.header = val },
    SET_SIDEBAR(state, val) { state.sidebar = val },
    SET_FOOTER(state, val) { state.footer = val },
    SET_BREADCRUMBS(state, val) { state.breadcrumbs = val},
    SHOW_SNACKBAR(state, snackbar) { state.snackbar = { show: true, color: snackbar.color, message: snackbar.message } },
    CLEAR_SNACKBAR(state) { state.snackbar = { show: false, color: '', message: '' } },
    SET_DRAWER(state, condition) { state.drawer = condition },
    SET_LOADING(state, val) { state.loading = val },
    SET_CONFIRM_DIALOG(state, val) { state.confirm_dialog = val },
    SET_REF(state, refs) {
      state.academic.academic_types = refs.academic_types;
      state.academic.report_types = refs.academic_report_types;
      state.document.document_types = refs.document_types;
      state.document.staff_types = refs.staff_types;
      state.form.form_groups = refs.form_groups;
      state.news.news_types = refs.news_types;
      state.km.km_groups = refs.km_groups;
      state.departments = refs.departments;
      state.position_works = refs.position_works;
      state.announcement_types = refs.announcement_types;
    }
  },
  actions: {
    async get_ref({ commit }) {
      try {
        const { data } = await axios.get(`/ref`);
        commit('SET_REF', data);
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async position_works() {
      try {
        const { data } = await axios.get(`/ref/position_works`);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    }
  },
  modules: {
    auth: auth,
    news: news,
    academic: academic,
    document: document,
    form: form,
    activity: activity,
    slide: slide,
    about: about,
    faq: faq,
    calendar: calendar,
    km: km,
    job: job,
  }
})
